// extracted by mini-css-extract-plugin
export default {"wrapper":"Ve","focus":"We","button":"Xe","options":"Ye","label":"Ze"};